import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import useSWRImmutable from "swr/immutable";
import { useCountries } from "../../../../common/api/useCountries";
import { Dropdown } from "../../../../common/components";
import { ADDRESS_KEYS } from "../../constants";
import { Address, TimeZone } from "../../models";
import { AddressKey } from "../../types";

interface AddressMaskProps {
    address: Address;
    timeZone?: TimeZone;
    isReadOnly?: boolean;
    onChangeAddress?: (prop: AddressKey, value: string) => void;
    onChangeTimeZone?: (value: TimeZone) => void;
}

const AddressMask = (props: AddressMaskProps) => {
    const {
        address,
        onChangeAddress = () => {},
        onChangeTimeZone = () => {},
        isReadOnly = false,
        timeZone,
    } = props;

    const { t } = useTranslation(["common", "setUpSpaces"]);

    const { countries } = useCountries();

    const { data: timezones } = useSWRImmutable(
        "/api/static-data/v1/timezones"
    );

    return (
        <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-8">
                <div className="grid gap-1">
                    <label>{t("setUpSpaces:address.street")}*</label>
                    <InputText
                        name={
                            t("setUpSpaces:address.street") ||
                            ADDRESS_KEYS.STREET
                        }
                        value={address?.street}
                        onChange={(e) =>
                            onChangeAddress(ADDRESS_KEYS.STREET, e.target.value)
                        }
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="col-span-12 md:col-span-4">
                <div className="grid gap-1">
                    <label>{t("setUpSpaces:address.number")}*</label>
                    <InputText
                        name={
                            t("setUpSpaces:address.number") ||
                            ADDRESS_KEYS.NUMBER
                        }
                        value={address?.number}
                        onChange={(e) =>
                            onChangeAddress(ADDRESS_KEYS.NUMBER, e.target.value)
                        }
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="col-span-12 md:col-span-6">
                <div className="grid gap-1">
                    <label>{t("setUpSpaces:address.zipCode")}</label>
                    <InputText
                        name={
                            t("setUpSpaces:address.zipCode") ||
                            ADDRESS_KEYS.ZIP_CODE
                        }
                        value={address?.zipCode}
                        onChange={(e) =>
                            onChangeAddress(
                                ADDRESS_KEYS.ZIP_CODE,
                                e.target.value
                            )
                        }
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="col-span-12 md:col-span-6">
                <div className="grid gap-1">
                    <label>{t("setUpSpaces:address.city")}*</label>
                    <InputText
                        name={
                            t("setUpSpaces:address.city") || ADDRESS_KEYS.CITY
                        }
                        value={address?.city}
                        onChange={(e) =>
                            onChangeAddress(ADDRESS_KEYS.CITY, e.target.value)
                        }
                        disabled={isReadOnly}
                    />
                </div>
            </div>
            <div className="col-span-12 md:col-span-6">
                <label>{t("setUpSpaces:address.country")}*</label>
                <Dropdown
                    options={countries}
                    value={address?.country}
                    optionValue="code"
                    optionLabel="name"
                    disabled={isReadOnly}
                    filter
                    onChange={(event) => {
                        onChangeAddress(ADDRESS_KEYS.COUNTRY, event.value);
                    }}
                    className="w-full"
                />
            </div>
            <div className="col-span-12 md:col-span-6">
                <label>{t("setUpSpaces:address.timeZone")}*</label>
                <Dropdown
                    required={!isReadOnly}
                    options={timezones}
                    value={timeZone}
                    optionLabel="displayName"
                    disabled={isReadOnly}
                    filter
                    onChange={(event) => onChangeTimeZone(event.value)}
                    className="w-full"
                />
            </div>
        </div>
    );
};

export default AddressMask;
